import { Modal } from "antd";
import React, { useCallback, useState } from "react";
import { CloseIcon } from "../../../asset";
import { DateRange } from "react-date-range";
import dayjs from "dayjs";

const ModalDateRangePicker = ({
  isModalDatePickerOpen,
  handleOk,
  handleCancel,
  sendToParents,
}) => {
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const onCancel = useCallback(() => {
    handleCancel();
  }, [handleCancel]);

  const onApplyDateRange = useCallback(() => {
    const startDate = dayjs(state[0].startDate).format("YYYY-MM-DD");
    const endDate = dayjs(state[0].endDate).format("YYYY-MM-DD");

    if (sendToParents) {
      sendToParents(startDate, endDate);
    }
  }, [sendToParents, state]);

  return (
    <Modal
      title={null}
      open={isModalDatePickerOpen}
      onOk={handleOk}
      onCancel={onCancel}
      closeIcon={null}
      footer={null}
    >
      <div className="flex flex-col">
        <div className="flex justify-between">
          <span className="text-[#090909] font-sans font-bold text-2xl">
            Custom Period
          </span>
          <button onClick={handleCancel}>
            <img src={CloseIcon} alt="close-icons" />
          </button>
        </div>
        <DateRange
          onChange={(item) => setState([item.selection])}
          months={2}
          ranges={state}
          direction="horizontal"
        />
      </div>
      <div className="btn-container">
        <button className="btn-cancel" onClick={onCancel}>
          Cancel
        </button>
        <button className="btn-next" onClick={onApplyDateRange}>
          Apply
        </button>
      </div>
    </Modal>
  );
};

export default ModalDateRangePicker;
